import { SearchRounded } from '@mui/icons-material';
import { Divider, Grid, OutlinedInput } from '@mui/material';
import axios from 'axios';
import React, { useEffect, useState } from 'react';
import Screen from '../../components/fragments/Screen';
import CardHome from '../../components/legacy/CardHome';
import FabActions from './FabActions';

export default function MyBibleScreen() {
    const [versions, setVersions] = useState([]);
    const [search, setSearch] = useState('');

    useEffect(() => {
        axios
            .get('https://api.scripture.api.bible/v1/bibles?language=eng', {
                headers: {
                    'api-key': '74d66efbae53bab5516e6c50cbaf17ea',
                },
            })
            .then((resp) => {
                setVersions(resp?.data?.data);
            });
    }, []);

    return (
        <Screen loading={!versions.length} authPass title="Bible Versions">
            <Grid item xs={12}>
                <OutlinedInput
                    fullWidth
                    color="primary"
                    value={search}
                    placeholder="Type to search"
                    startAdornment={<SearchRounded className="me-2" />}
                    onChange={(e) => setSearch(e.target.value)}
                />
            </Grid>
            {versions
                .filter(
                    ({ name }) =>
                        (name.includes('KJV') ||
                            name.includes('King James') ||
                            name.includes('Revised')) &&
                        name.toLowerCase().includes(search.toLocaleLowerCase())
                )
                .map(({ id, name }) => (
                    <CardHome
                        key={id}
                        link={`/bible/${id}`}
                        title={name}
                        full={true}
                    />
                ))}
            <Divider />
            {versions
                .filter(
                    ({ name }) =>
                        !name.includes('KJV') &&
                        !name.includes('King James') &&
                        !name.includes('Revised') &&
                        name.toLowerCase().includes(search.toLocaleLowerCase())
                )
                .map(({ id, name }) => (
                    <CardHome
                        key={id}
                        link={`/bible/${id}`}
                        title={name}
                        full={true}
                    />
                ))}
            <FabActions />
        </Screen>
    );
}
